import React from "react";
import "./SourceCode.css";

export default function SourceCode() {
  return (
    <div className="SourceCode">
      <p className="source-code-text">
        <a
          target="_blank"
          rel="noreferrer"
          href="https://github.com/VitalinaKuzmenko/Weather_Forecast_React"
        >
          Open-source code
        </a>
        , by Vitalina Kuzmenko
      </p>
    </div>
  );
}
